/**
 * @generated SignedSource<<fe805a56f175d6a4818c2b187f0b81d2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type processDefinitionsArchivedQueryDeleteMutation$variables = {
  ids: ReadonlyArray<string>;
};
export type processDefinitionsArchivedQueryDeleteMutation$data = {
  readonly deleteProcessDefinitions: boolean | null | undefined;
};
export type processDefinitionsArchivedQueryDeleteMutation = {
  response: processDefinitionsArchivedQueryDeleteMutation$data;
  variables: processDefinitionsArchivedQueryDeleteMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "ids"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "ids",
        "variableName": "ids"
      }
    ],
    "kind": "ScalarField",
    "name": "deleteProcessDefinitions",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "processDefinitionsArchivedQueryDeleteMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "processDefinitionsArchivedQueryDeleteMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "fa097d5035b2689f4d4c0a2344af6c9d",
    "id": null,
    "metadata": {},
    "name": "processDefinitionsArchivedQueryDeleteMutation",
    "operationKind": "mutation",
    "text": "mutation processDefinitionsArchivedQueryDeleteMutation(\n  $ids: [ID!]!\n) {\n  deleteProcessDefinitions(ids: $ids)\n}\n"
  }
};
})();

(node as any).hash = "204a88b7c7642bc54ccad481461f66c7";

export default node;
